/**
 * @generated SignedSource<<975677b8b25bc8a754b52b77a57d15c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MarkProjectAsFavoriteInput = {
  projectId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type markProjectAsFavoriteMutation$variables = {
  input: MarkProjectAsFavoriteInput;
};
export type markProjectAsFavoriteMutation$data = {
  readonly markProjectAsFavorite: {
    readonly project: {
      readonly node: {
        readonly id: string;
        readonly userRelationTypes: ReadonlyArray<string | null> | null;
      } | null;
    } | null;
  } | null;
};
export type markProjectAsFavoriteMutation = {
  variables: markProjectAsFavoriteMutation$variables;
  response: markProjectAsFavoriteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkProjectAsFavoritePayload",
    "kind": "LinkedField",
    "name": "markProjectAsFavorite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProjectTypeEdge",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectServiceProjectType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userRelationTypes",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "markProjectAsFavoriteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "markProjectAsFavoriteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dbfec3b975ead953379f88f46d0d109e",
    "id": null,
    "metadata": {},
    "name": "markProjectAsFavoriteMutation",
    "operationKind": "mutation",
    "text": "mutation markProjectAsFavoriteMutation(\n  $input: MarkProjectAsFavoriteInput!\n) {\n  markProjectAsFavorite(input: $input) {\n    project {\n      node {\n        id\n        userRelationTypes\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "50857c471ee017925e1adb06fefff7ab";

export default node;
